// const api_request = 'https://apialugmais.herokuapp.com'
// const api_request = 'http://localhost:3333'
// const api_request = 'http://epar.anvali.com.br:3333'
// const api_request = 'https://api.e2par.com:3333'
const api_request = 'https://apieparteste.anvali.com.br:3333'

export default api_request